// extracted by mini-css-extract-plugin
export default {"virtual":"virtual_virtual__Ovz06","left":"virtual_left__9emd+","wrapper":"virtual_wrapper__EGECJ"};